module.exports = __webpack_public_path__ + "static/img/6-2.50bf67d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/6-2.jpg
// module id = rZtd
// module chunks = 0